import { useManualQuery } from '@zenbusiness/application-commons-graphql';

import useConstBusinessEntityUuid from '#client/hooks/useConstBusinessEntityUuid';
import useUnitAccountId from '#client/hooks/useUnitAccountId';
import { GET_PAYMENTS_QUERY } from '#client/queries';

const useGetPayment = (id) => {
  const { businessEntityUuid } = useConstBusinessEntityUuid();
  const { unitAccountId } = useUnitAccountId();

  const [getPayments, { loading, data, error }] = useManualQuery(GET_PAYMENTS_QUERY, {
    noThrow: true,
    variables: {
      page: {
        pageSize: 1,
        page: 1
      },
      filter: {
        businessEntityUuid,
        counterpartyId: id
      }
    },
    skip: !businessEntityUuid || !unitAccountId,
    skipCache: true
  });

  return {
    getPayments,
    loading,
    data,
    error
  };
};

export default useGetPayment;
